import { createFileRoute } from '@tanstack/react-router'
import { CateringPage } from '@/components/catering/CateringPage'

// Kitchen flow Stage 2B: catering bookings. Renders a "not switched on" note
// unless GET /settings carries kitchen_flow=true.
export const Route = createFileRoute('/admin/catering')({
  component: CateringPage,
})
